import type { Accessory } from '@octave/contracts';
import { useMemo, useState } from 'react';

export interface AccessoryFilters {
  category?: string;
  searchQuery: string;
}

const defaultFilters: AccessoryFilters = {
  category: '',
  searchQuery: '',
};

export function useAccessoryFilters(accessories: Accessory[] = []) {
  const [filters, setFilters] = useState<AccessoryFilters>(defaultFilters);

  // Filtrer les accessoires selon les critères
  const filteredAccessories = useMemo(() => {
    if (!accessories || accessories.length === 0) return [];

    return accessories.filter((accessory) => {
      // Filtre par catégorie
      if (
        filters.category &&
        filters.category !== '' &&
        accessory.category !== filters.category
      ) {
        return false;
      }

      // Filtre par recherche textuelle
      if (filters.searchQuery && filters.searchQuery !== '') {
        const query = filters.searchQuery.toLowerCase();
        const matchesSearch =
          accessory.name.toLowerCase().includes(query) ||
          accessory.category.toLowerCase().includes(query);

        if (!matchesSearch) return false;
      }

      return true;
    });
  }, [accessories, filters]);

  const updateFilters = (newFilters: Partial<AccessoryFilters>) => {
    setFilters((prev) => ({ ...prev, ...newFilters }));
  };

  const clearFilters = () => {
    setFilters(defaultFilters);
  };

  return {
    filters,
    filteredAccessories,
    updateFilters,
    clearFilters,
  };
}
